import React from 'react'
import { SVGIconProps } from '../types'
const SvgSpeedFast = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        stroke="#233745"
        strokeWidth={1.5}
        d="M8 3.15a6.53 6.53 0 0 1 4.631 1.918A6.53 6.53 0 0 1 14.55 9.7c0 1.271-.165 2.253-.553 2.923l-.094.15-3.138.03q.368-.066.728-.138c.833-.166 1.579-.382 2.171-1.312.17-.266.281-.52.349-.764a15 15 0 0 0-.677-.324 23 23 0 0 0-1.632-.627c-1.384-.484-2.981-.943-3.447-.976l-.185-.005-.181.01c-.48.044-.92.24-1.267.542a2.24 2.24 0 0 0-.769 1.541 2.24 2.24 0 0 0 1.09 2.089l-4.614.043c-.676-.834-.881-1.863-.881-3.182a6.53 6.53 0 0 1 1.918-4.632A6.53 6.53 0 0 1 8 3.15Zm-4.85 6.5c-.414 0-.79.168-1.06.44a1.495 1.495 0 0 0 0 2.121c.27.271.646.439 1.06.439s.79-.168 1.06-.44a1.495 1.495 0 0 0 0-2.121 1.5 1.5 0 0 0-1.06-.439Zm.6-4.1c-.414 0-.79.168-1.06.44a1.495 1.495 0 0 0 0 2.121c.27.271.646.439 1.06.439s.79-.168 1.06-.44a1.495 1.495 0 0 0 0-2.121 1.5 1.5 0 0 0-1.06-.439Zm8.5 0c-.414 0-.79.168-1.06.44a1.495 1.495 0 0 0 0 2.121c.27.271.646.439 1.06.439s.79-.168 1.06-.44a1.495 1.495 0 0 0 0-2.121 1.5 1.5 0 0 0-1.06-.439ZM8 3.25c-.414 0-.79.168-1.06.44a1.495 1.495 0 0 0 0 2.121c.27.271.646.439 1.06.439s.79-.168 1.06-.44a1.495 1.495 0 0 0 0-2.121A1.5 1.5 0 0 0 8 3.25Z"
      />
    </g>
  </svg>
)
export default SvgSpeedFast
